export const ESubscriptionRouteName = {
  PDL: 'pdl',
  CONTRACT_NUMBER_REGISTRATION: 'contract-number',
  INSTALLATION_ADDRESS: 'installation-address',
  EQUIPMENTS: 'equipments',
  SOLAR_INSTALLATION: 'solar-installation',
  INSTALLER_INFORMATIONS: 'installer-informations',
  IMPOSSIBLE_SUBSCRIPTION: 'impossible-subscription',
  PHYSICAL_BATTERY: 'physical-battery',
  SOLAR_PRODUCTION_STORAGE: 'solar-production-storage',
  CASHBACK_ACTIVATION: 'cashback-activation',
  ELECTRICITY_CONSUMPTION: 'electricity-consumption',
  ELECTRICITY_SUPPLIER: 'electricity-supplier',
  BILLING_MODE: 'billing-mode',
  CONTRACTOR_INFORMATIONS: 'contractor-informations',
  BILLING_INFORMATIONS: 'billing-informations',
  INFORMATIONS_SUMMARY: 'informations-summary',
  CONTRACT_SIGNATURE: 'contract-signature',
  CONTRACT_SIGNED: 'contract-signed',
} as const;
